module.exports = __webpack_public_path__ + "img/second.0123d624.jpg";